import { z } from 'zod';

// Base channel type for plan relationships
export interface PlanChannel {
  id: number;
  name: string;
}

export interface PlanFeature {
  id: string;
  name: string;
  description?: string;
  included: boolean;
  order: number;
}

export interface Plan {
  id: number;
  name: string;
  description: string | null;
  provider_id: number;
  version_id: number;
  monthly_price: number | null;
  yearly_price: number | null;
  color_index: number;
  features: PlanFeature[];
  is_addon: boolean | null;
  created_at: string;
  // Channel relationships
  channel_count: number;
  channels: PlanChannel[];
  channel_plans?: Array<{
    channel: PlanChannel;
  }>;
}

export const planFeatureSchema = z.object({
  id: z.string(),
  name: z.string().min(1, 'Feature name is required'),
  description: z.string().optional(),
  included: z.boolean(),
  order: z.number()
});

export const planSchema = z.object({
  name: z.string().min(1, 'Plan name is required'),
  description: z.string().nullable(),
  monthly_price: z.number().nullable(),
  yearly_price: z.number().nullable(),
  color_index: z.number().min(0).max(30),
  features: z.array(planFeatureSchema).optional(),
  is_addon: z.boolean().nullable().optional()
});

export type PlanFormData = z.infer<typeof planSchema>;